import { ComponentType } from 'react';
import { QualifyingQuestionPartial } from '../partials/qualifyingQuestion/QualifyingQuestionPartial';
import { GuidanceChoicePartial } from '../partials/guidanceChoice/GuidanceChoicePartial';
import { GuidanceConfirmationPartial } from '../partials/guidanceConfirmation/GuidanceConfirmationPartial';
import { RiskWarningsPartial } from '../partials/riskWarnings/RiskWarningsPartial';

export type StageKey =
  | 'qualifyingQuestion'
  | 'guidanceChoice'
  | 'pleaseConfirm'
  | 'riskWarnings';

export interface StageProps {
  answers: Readonly<Record<string, string>>;
  onSubmit: (answers: Readonly<Record<string, string>>) => void | Promise<void>;
  currentStageKey: StageKey;
}

export const stageComponentMap = {
  qualifyingQuestion: QualifyingQuestionPartial,
  guidanceChoice: GuidanceChoicePartial,
  pleaseConfirm: GuidanceConfirmationPartial,
  riskWarnings: RiskWarningsPartial,
} satisfies Record<StageKey, ComponentType<StageProps>>;

export function isStageKey(maybeStageKey: string): maybeStageKey is StageKey {
  return maybeStageKey in stageComponentMap;
}
